import React, { useMemo, useState } from 'react'
import useTrans from '@hooks/useTrans'
import { cn } from '@utils/safeTs'
import { Plus } from '@components/icons'
import { Button, FormField, FormTextarea, TutorialItem } from '@components/atoms'
import EditorSidebarText from '@components/molecules/EditorSidebarText/EditorSidebarText'
import styles from './EditorTextsSidebar.module.sass'
import { useEditorContext } from 'context/EditorContext'
import { useTutorialContext } from 'context/TutorialContext'

interface Props {
  onAdd?: (v: { text: string }) => void
  className?: string
}

const EditorTextsSidebar = (props: Props) => {
  const { onAdd, className = '' } = props

  const t = useTrans()
  const { activeCanvas, colorLimits } = useEditorContext()
  const [newValue, setNewValue] = useState('')
  const { nextTutorialItem } = useTutorialContext()

  const handleAdd = () => {
    if (!newValue) return
    if (onAdd) onAdd({ text: newValue })
    setNewValue('')
    nextTutorialItem('editor', 2)
  }

  const textsInCanvas = useMemo(() => {
    return activeCanvas?.data?.filter((oc) => oc.etype === 'text') || []
  }, [activeCanvas?.data])

  return (
    <div className={cn(styles.root, className)}>
      {textsInCanvas.length > 0 && (
        <div className={styles.body}>
          <div className={styles.list}>
            {textsInCanvas.map((t) => (
              <EditorSidebarText
                key={t.id}
                text={t}
                selected={t.isSelected}
                onRemove={() => activeCanvas.actions?.handleObjectAction(t.id, 'delete')}
                onColorChange={(id, o, n) => activeCanvas?.actions?.handleColorChange(t.id, o, n)}
                onObjectAction={(id, action, payload) =>
                  activeCanvas?.actions?.handleObjectAction(t.id, action, payload)
                }
                colorLimits={colorLimits}
              />
            ))}
          </div>
        </div>
      )}

      <div className={styles.new}>
        <TutorialItem
          tutorialKey={'editor'}
          index={1}
          direction="right-top"
          content={t('Inserisci il testo e clicca su "Aggiungi" per inserirlo nell’area di stampa')}
          overlayClassName={styles.tutorialItemOverlay}
        >
          <FormField
            // label={t('Nuovo testo')}
            styleVariant="editor"
            id="editortextsidebar_new_text"
          >
            <FormTextarea
              id="editortextsidebar_new_text"
              placeholder={t('Inserisci il testo')}
              value={newValue}
              onChange={(e) => setNewValue(e.target.value)}
              onFocus={() => nextTutorialItem('editor', 2)}
            />
          </FormField>
        </TutorialItem>

        <div className={styles.newCtaBox}>
          <Button
            className={styles.newCtaButton}
            variant="primary"
            label={t('Aggiungi')}
            icon={<Plus />}
            icon_pos="right"
            size="small"
            onClick={handleAdd}
            disabled={!newValue}
          />
        </div>
      </div>
    </div>
  )
}

export default EditorTextsSidebar
